import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import MaskedInput from 'react-text-mask';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
// import { APP_ENV } from '@config';
import utils from '@utils';
import {
	ApplicationService,
	SignupService,
	UserService,
	JobService,
	OrganizationService,
} from '@services';
import actions from '@redux/app';
import RequestJobImage from '../../images/request-job.png';

import './RequestJob.scss';

const dateMask = [/[0-1]/, /[0-9]/, '/', /[0-3]/, /[0-9]/, '/', /2/, /0/, /[2-9]/, /[0-9]/];
const timeMask = [/[0-1]/, /[0-9]/, ':', /[0-5]/, /[0-9]/, ' ', /(A|P)/i, /M/i];
const phoneMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
const { isDesktopSafari, isIOSDevice } = utils.getBrowserInfo();

// Determine minimum date for native date picker
const formatMinimumDate = (date = new Date()) => {
	const offset = date.getTimezoneOffset();
	const newDate = new Date(date.getTime() - (offset * 60 * 1000));
	// Set minimum date to next day as workaround to avoid API error
	newDate.setDate(newDate.getDate() + 1);
	return newDate.toISOString().split('T')[0];
};

class RequestJob extends Component {
	constructor(props) {
		super(props);

		this.state = {
			loggedIn        : !!localStorage.getItem('t'),
			step            : 1,
			totalSteps      : localStorage.getItem('t') ? 2 : 3,
			loading         : false,
			showAgencyInfo  : false,
			whiteLabelToken : undefined,
			logoURL         : '',
			agencyName      : '',
			showPassword    : false,
			showConfirmPass : false,
			usStates        : [],
			form            : {
				JobDate     : '',
				StartTime   : '',
				EndTime     : '',
				City        : '',
				StateId     : '',
				ZipCode     : '',
				FirstName   : '',
				LastName    : '',
				Business    : '',
				PhoneNumber : '',
				Email       : '',
				Password    : '',
				ConfirmPass : '',
			},
		};
		this.rkLogoURL = '/images/logo-blue.svg';
	}

	componentDidMount() {
		const { loggedIn } = this.state;
		ApplicationService.getUSStates()
			.then(({ data }) => {
				const usStates = data.map(({ Id, Name, Abbreviation }) => ({ Id, Name, Abbreviation }));

				this.setState({ usStates });
			})
			.catch(() => {
				utils.notify({
					type    : 'error',
					message : 'Error loading US States',
					timeOut : 1500,
				});
			});
		if (loggedIn) {
			const { user : { Organization : { Name : Business }, ...user } } = this.props;
			const {
				City,
				StateId,
				Zip : ZipCode,
				FirstName,
				LastName,
				CellPhone : PhoneNumber,
				Email,
			} = user;

			this.setState((prevState) => ({
				form : {
					...prevState.form,
					City,
					StateId,
					ZipCode,
					FirstName,
					LastName,
					PhoneNumber,
					Email,
					Business,
				},
			}));
		}

		const token = new URLSearchParams(window.location.search).get('token');
		OrganizationService.getDetailsForToken(token)
			.then(({ data : { Name, OrganizationLogoUrl } }) => this.setState({
				agencyName      : Name || '',
				logoURL         : OrganizationLogoUrl || this.rkLogoURL,
				whiteLabelToken : token || undefined,
				showAgencyInfo  : true,
			})).catch(() => this.setState({ showAgencyInfo : true, logoURL : this.rkLogoURL }));
	}

	updateForm = (field) => ({ target : { value } }) => {
		if (field === 'ZipCode' && value.replace(/[0-9]/gi, '').length > 0) return;
		if (field === 'PhoneNumber' && value.replace(/[0-9()\s-]/gi, '').length > 0) return;
		this.setState((prevState) => ({
			form : {
				...prevState.form,
				[field] : value,
			},
		}));
	}

	toggleShowPassword = (id) => this.setState((prevState) => ({ [id] : !prevState[id] }));

	isNextVisible = () => {
		const { step, totalSteps, form } = this.state;
		if (step === 1 && form.JobDate.trim() && form.StartTime.trim() && form.EndTime.trim()
			&& form.City.trim() && form.StateId && form.ZipCode.trim().length === 5 && form.Business.trim()) {
			return true;
		}
		if (totalSteps === 3 && step === 2 && form.FirstName.trim() && form.LastName.trim()
			&& form.PhoneNumber.trim().length === 14 && (/^\(\d{3}\) \d{3}-\d{4}$/gi).test(form.PhoneNumber)
			&& (/^\S.*@\S.*\.\S{2,}$/gi).test(form.Email) && form.Password.trim().length >= 7 && form.ConfirmPass === form.Password) {
			return true;
		}
		return false;
	}

	nextStep = () => {
		const { loggedIn, step, totalSteps } = this.state;
		if (step === totalSteps - 1) {
			// Submit form
			this.setState({ loading : true }, () => {
				if (loggedIn) this.sendJobRequest();
				else this.signUpAndRequest();
			});
		} else {
			this.setState((prevState) => ({ step : prevState.step + 1 }));
		}
	}

	signUpAndRequest = () => {
		const {
			whiteLabelToken : OrganizationToken,
			form : {
				City,
				StateId,
				ZipCode : Zip,
				Business : CompanyName,
				FirstName,
				LastName,
				Email,
				PhoneNumber : MobilePhone,
				Password,
				ConfirmPass : ConfirmPassword,
			},
		} = this.state;
		const { history, login, receiveUser } = this.props;

		const params = {
			FirstName,
			LastName,
			Email,
			MobilePhone,
			Password,
			ConfirmPassword,
			CompanyName,
			OrganizationToken,
			Origin : 'Request Job',
		};

		SignupService.clientStep1(params)
			.then((signupResponse) => UserService.login({ email : Email, password : Password }).then(({ data : user }) => {
				login();
				receiveUser(user);
				this.setState({ loggedIn : true });
				this.sendJobRequest();
				return signupResponse;
			}).catch((error) => error))
			.then(({ data : { SignUpToken } }) => SignupService.attachAddress(SignUpToken, {
				StreetAddress : 'n/a',
				City,
				StateId,
				Zip,
			}))
			.catch(({ response : { data } }) => {
				this.setState({ loading : false });
				if (data.find((e) => e.ErrorCode === 22 || e.ErrorCode === 26)) {
					const clientExists = data.find((e) => e.ErrorCode === 26);
					utils.notify({
						type    : clientExists ? 'info' : 'error',
						title   : 'An account with this email exists',
						message : clientExists ? 'You will be redirected to the login page.' : 'Please use a different email address.',
						timeOut : clientExists ? 1500 : 2500,
					});
					if (clientExists) {
						const timer = setTimeout(() => {
							clearTimeout(timer);
							history.push({
								pathname : '/login',
								search   : `?action=request&user=${encodeURIComponent(Email)}`,
							});
						}, 2000);
					}
				} else {
					utils.notify({
						type    : 'error',
						message : 'An error occurred. Please try again.',
						timeOut : 1500,
					});
				}
			});
	}

	sendJobRequest = () => {
		const {
			agencyName,
			usStates,
			form : {
				JobDate,
				StartTime,
				EndTime,
				City,
				StateId,
				ZipCode,
				Business,
				FirstName,
				LastName,
				PhoneNumber,
				Email,
			},
		} = this.state;
		let StartDateTime = new Date(`${JobDate} ${StartTime}`);
		let EndDateTime = new Date(`${JobDate} ${EndTime}`);

		// iOS required specific date formatting to parse into a date object
		if (isIOSDevice) {
			StartDateTime = new Date(`${JobDate.replace(/-/gi, '/')} ${StartTime}`);
			EndDateTime = new Date(`${JobDate.replace(/-/gi, '/')} ${EndTime}`);
		}

		// If job end date is less than job start date, this is an overnight job and we should add one day to the current end date
		if (EndDateTime <= StartDateTime) {
			EndDateTime.setDate(EndDateTime.getDate() + 1);
		}
		let JobDetails = `***New Job Request - ${agencyName || 'RollKall'}***\n\nBusiness: ${Business}`;
		JobDetails += `\n\nContact: ${FirstName} ${LastName}\n${PhoneNumber}\n${Email}`;

		// Build job request object
		const jobRequest = {
			City,
			StateId,
			ZipCode,
			JobDetails,
			LocationTypeId : 26,
			JobEventTypeId : 1,
			LocationName   : Business, // To show Organization Name on job request email sent to CX
			StreetAddress  : 'N/A',
			StartDateTime  : new Date(StartDateTime.getTime() - (StartDateTime.getTimezoneOffset() * 60000)).toISOString().slice(0, -1),
			EndDateTime    : new Date(EndDateTime.getTime() - (EndDateTime.getTimezoneOffset() * 60000)).toISOString().slice(0, -1),
			ReferredBy     : '',
		};
		JobService.saveClientJobRequest(jobRequest)
			.then(() => {
				// if (APP_ENV === 'production') {
				const dateOptions = {
					year   : '2-digit',
					month  : '2-digit',
					day    : '2-digit',
					hour   : '2-digit',
					minute : '2-digit',
					hour12 : true,
				};
				const state = usStates.find(({ Id }) => Id.toString() === StateId.toString());
				JobDetails += `\n\nLocation: ${City}, ${state ? state.Abbreviation : '(State not found)'} ${ZipCode}`;
				JobDetails += `\n\nStart: ${StartDateTime.toLocaleString('en-US', dateOptions)}\nEnd: ${EndDateTime.toLocaleString('en-US', dateOptions)}`;
				const zdBody = {
					ticket : {
						comment  : { body : JobDetails },
						priority : 'high',
						subject  : `***New Job Request - ${agencyName || 'RollKall'}***`,
					},
				};
				axios.post('https://rollkall.zendesk.com/api/v2/tickets',
					zdBody,
					{ headers : { Authorization : 'Basic dGRvdmVyQHJvbGxrYWxsLmNvbS90b2tlbjowSkJwaGh1WlJ6ZGI3bGZlcENmTTFISHFLYXlSd1h4YmZJSEMyT3RH' } });
				// }
				// Submit and proceed on success
				this.setState((prevState) => ({ step : prevState.step + 1 }));
			})
			.catch(() => {
				this.setState({ loading : false });
				utils.notify({
					type    : 'error',
					message : 'An error occurred. Please try again.',
					timeOut : 1500,
				});
			});
	}

	requestAnotherJob = () => {
		this.setState((prevState) => ({
			step            : 1,
			totalSteps      : 2,
			loading         : false,
			showPassword    : false,
			showConfirmPass : false,
			form            : {
				...prevState.form,
				JobDate   : '',
				StartTime : '',
				EndTime   : '',
			},
		}));
	}

	goBack = () => this.setState((prevState) => ({ step : prevState.step - 1 }));

	render() {
		const {
			step,
			totalSteps,
			loading,
			showAgencyInfo,
			whiteLabelToken,
			logoURL,
			agencyName,
			showPassword,
			showConfirmPass,
			usStates,
			form,
			loggedIn,
		} = this.state;

		return (
			<div id="request-job">
				<nav className="navbar navbar-light bg-light">
					<Link to="/" className={`navbar-brand ${showAgencyInfo ? '' : 'invisible'}`}>
						<img src={logoURL} alt="Organization logo" className={`org-logo ${showAgencyInfo ? '' : 'invisible'}`} />
						<If condition={whiteLabelToken}>
							{agencyName}
						</If>
					</Link>
				</nav>
				<div className="progress">
					<div
						className={`progress-bar step${step}of${totalSteps}`}
						role="progressbar"
						aria-valuenow={((step / totalSteps) * 100).toFixed(2)}
						aria-valuemin="0"
						aria-valuemax="100"
					>
						<span className="sr-only">{`${((step / totalSteps) * 100).toFixed(2)}% Complete`}</span>
					</div>
				</div>
				<div className="container">
					<div className="row">
						<div className={step === totalSteps ? 'hidden' : 'col-sm-6 col-md-5 col-md-offset-1 hidden-xs'}>
							<button
								type="button"
								className={`btn ${totalSteps === 3 && step === 2 ? 'btn-link' : 'invisible'}`}
								disabled={loading}
								onClick={this.goBack}
							>
								<i className="rkf rkf-arrow-left" />
								&nbsp;
								Back
							</button>
							<br />
							<img src={RequestJobImage} className="img-responsive img-rounded" alt="step" />
						</div>
						<div className={step === totalSteps ? 'text-center col-sm-6 col-sm-offset-3' : 'col-sm-6 col-md-5'}>
							<Choose>
								<When condition={step === 1}>
									<h3 className="col-sm-12"><strong>When and where do you need security?</strong></h3>
									<form id="step1-form">
										<div className="col-sm-12 form-group">
											<label htmlFor="job-date"><strong>Date</strong></label>
											<Choose>
												<When condition={isDesktopSafari}>
													<MaskedInput
														name="job-date"
														id="job-date"
														type="text"
														mask={dateMask}
														className="form-control"
														value={form.JobDate}
														onChange={this.updateForm('JobDate')}
														placeholder="mm/dd/yyyy"
													/>
												</When>
												<Otherwise>
													<input
														type="date"
														name="job-date"
														id="job-date"
														className="form-control"
														value={form.JobDate}
														onChange={this.updateForm('JobDate')}
														min={formatMinimumDate()}
													/>
												</Otherwise>
											</Choose>
										</div>
										<div className="col-sm-6 form-group">
											<label htmlFor="job-start"><strong>Start Time</strong></label>
											<Choose>
												<When condition={isDesktopSafari}>
													<MaskedInput
														id="job-start"
														name="job-start"
														type="text"
														mask={timeMask}
														className="form-control"
														value={form.StartTime}
														onChange={this.updateForm('StartTime')}
														placeholder="09:00 AM"
													/>
												</When>
												<Otherwise>
													<input
														type="time"
														name="job-start"
														id="job-start"
														className="form-control"
														value={form.StartTime}
														onChange={this.updateForm('StartTime')}
													/>
												</Otherwise>
											</Choose>
										</div>
										<div className="col-sm-6 form-group">
											<label htmlFor="job-end"><strong>End Time</strong></label>
											<Choose>
												<When condition={isDesktopSafari}>
													<MaskedInput
														id="job-end"
														name="job-end"
														type="text"
														mask={timeMask}
														className="form-control"
														value={form.EndTime}
														onChange={this.updateForm('EndTime')}
														placeholder="05:00 PM"
													/>
												</When>
												<Otherwise>
													<input
														type="time"
														name="job-end"
														id="job-end"
														className="form-control"
														value={form.EndTime}
														onChange={this.updateForm('EndTime')}
													/>
												</Otherwise>
											</Choose>
										</div>
										<div className="col-sm-12 form-group">
											<label htmlFor="job-city"><strong>City</strong></label>
											<input
												name="job-city"
												id="job-city"
												className="form-control"
												value={form.City}
												placeholder="City"
												onChange={this.updateForm('City')}
											/>
										</div>
										<div className="col-sm-6 form-group">
											<label htmlFor="job-state"><strong>State</strong></label>
											<select
												id="job-state"
												name="job-state"
												className={`form-control${form.StateId === '' ? ' no-option' : ''}`}
												value={form.StateId}
												onChange={this.updateForm('StateId')}
											>
												<option value="">State</option>
												{usStates.map(({ Id, Name }) => (
													<option key={`state-${Id}`} value={Id}>{Name}</option>
												))}
											</select>
										</div>
										<div className="col-sm-6 form-group">
											<label htmlFor="job-zipcode"><strong>Zip Code</strong></label>
											<input
												type="tel"
												id="job-zipcode"
												name="job-zipcode"
												className="form-control"
												maxLength="5"
												value={form.ZipCode}
												placeholder="Zip Code"
												onChange={this.updateForm('ZipCode')}
											/>
										</div>
										<div className="col-sm-12 form-group">
											<label htmlFor="job-business">
												<strong>Business Name</strong>
											</label>
											<input
												id="job-business"
												name="job-business"
												className="form-control"
												value={form.Business}
												placeholder="Business Name"
												onChange={this.updateForm('Business')}
												disabled={loggedIn}
											/>
										</div>
									</form>
								</When>
								<When condition={totalSteps === 3 && step === 2}>
									<h3 className="col-sm-12"><strong>Please enter your contact information</strong></h3>
									<form id="step2-form">
										<div className="col-sm-6 form-group">
											<label htmlFor="job-firstname"><strong>First Name</strong></label>
											<input
												id="job-firstname"
												name="job-firstname"
												className="form-control"
												value={form.FirstName}
												placeholder="First Name"
												onChange={this.updateForm('FirstName')}
											/>
										</div>
										<div className="col-sm-6 form-group">
											<label htmlFor="job-lastname"><strong>Last Name</strong></label>
											<input
												id="job-lastname"
												name="job-lastname"
												className="form-control"
												value={form.LastName}
												placeholder="Last Name"
												onChange={this.updateForm('LastName')}
											/>
										</div>
										<div className="col-sm-12 form-group">
											<label htmlFor="job-phone"><strong>Phone Number</strong></label>
											<MaskedInput
												type="tel"
												id="job-phone"
												name="job-phone"
												className="form-control"
												placeholder="(000) 000-0000"
												value={form.PhoneNumber}
												mask={phoneMask}
												onChange={this.updateForm('PhoneNumber')}
											/>
										</div>
										<div className="col-sm-12 form-group">
											<label htmlFor="job-email">
												<strong>Email</strong>
												&nbsp;
												<span>(This will be your username.)</span>
											</label>
											<input
												id="job-email"
												name="job-email"
												className="form-control"
												value={form.Email}
												placeholder="Email"
												onChange={this.updateForm('Email')}
											/>
										</div>
										<div className="col-sm-12 form-group">
											<label htmlFor="job-password"><strong>Password</strong></label>
											<input
												type={showPassword ? 'text' : 'password'}
												id="job-password"
												name="job-password"
												className="form-control"
												placeholder="At least 7 characters"
												value={form.Password}
												onChange={this.updateForm('Password')}
											/>
											<button
												tabIndex="-1"
												aria-label="Show Password"
												title="Show Password"
												type="button"
												id="showPassword"
												className={`btn btn-link rkf ${showPassword ? 'rkf-eye-hidden' : 'rkf-eye'}`}
												onClick={({ target : { id } }) => this.toggleShowPassword(id)}
											/>
										</div>
										<div className="col-sm-12 form-group">
											<label htmlFor="job-confirmPass"><strong>Confirm Password</strong></label>
											<input
												type={showConfirmPass ? 'text' : 'password'}
												id="job-confirmPass"
												name="job-confirmPass"
												className="form-control"
												value={form.ConfirmPass}
												placeholder="At least 7 characters"
												onChange={this.updateForm('ConfirmPass')}
											/>
											<button
												tabIndex="-1"
												aria-label="Show Confirm Password"
												title="Show Confirm Password"
												type="button"
												id="showConfirmPass"
												className={`btn btn-link rkf ${showConfirmPass ? 'rkf-eye-hidden' : 'rkf-eye'}`}
												onClick={({ target : { id } }) => this.toggleShowPassword(id)}
											/>
										</div>
									</form>
								</When>
								<When condition={step === totalSteps}>
									<img src="/images/checkmark_new.png" alt="Request successful" />
									<h2><strong>Request Submitted</strong></h2>
									<br />
									Thank you, your job request has been created successfully.
									Your request will be reviewed and we will reach out within 1 business day to confirm.
									<br />
									<br />
									If you have any questions, please email us at
									&nbsp;
									<a href="mailto:support@rollkall.com">support@rollkall.com</a>
									.
									<br />
									<br />
									<button type="button" className="btn btn-primary" onClick={this.requestAnotherJob}>
										Request Another Job
									</button>
								</When>
							</Choose>
							<div className={`col-xs-6 ${totalSteps === 3 && step === 2 ? 'visible-xs-block' : 'hidden'}`}>
								<button
									type="button"
									className="btn btn-default btn-block"
									onClick={this.goBack}
									disabled={loading}
								>
									Back
								</button>
							</div>
							<div className={`col-sm-12 ${step === 2 ? 'col-xs-6' : ''}`}>
								<button
									type="button"
									className={`btn btn-primary btn-block ${this.isNextVisible() ? '' : 'invisible'}`}
									onClick={this.nextStep}
									disabled={loading}
								>
									{loading ? 'Please Wait...' : 'Next'}
								</button>
							</div>
						</div>
					</div>
				</div>
				<div className="text-center powered-by">
					<If condition={whiteLabelToken}>
						Powered by
						&nbsp;
						<img src={this.rkLogoURL} className="org-logo" alt="RollKall logo" />
					</If>
				</div>
			</div>
		);
	}
}

const mapStateToProps = ({ app : { user } }) => ({ user });

const mapDispatchToProps = (dispatch) => ({
	login       : bindActionCreators(actions, dispatch).login,
	receiveUser : bindActionCreators(actions, dispatch).receiveUser,
});

RequestJob.propTypes = {
	login       : PropTypes.func.isRequired,
	receiveUser : PropTypes.func.isRequired,
	history     : PropTypes.object,
	user        : PropTypes.object,
};

RequestJob.defaultProps = { history : {}, user : {} };

export default connect(mapStateToProps, mapDispatchToProps)(RequestJob);
